import { Container } from "react-bootstrap";
import { GeoAlt, TelephoneFill } from "react-bootstrap-icons";
import LeafDivider from "../ui/LeafDivider";
import "../style/Herocamp.css";

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send?phone=916363018056&text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20Kote%20Cafe.";

const Herocamp = () => {
  return (
    <section className="camp-hero">
      <Container className="container-narrow camp-hero__inner">
        <div className="camp-hero__copy">
          <span className="font-kannada camp-hero__greeting">ಸ್ವಾಗತ 👋</span>
          <h1 className="camp-hero__title">
            Welcome to <span className="highlight">Kote Cafe</span>
          </h1>
          <p className="camp-hero__subtitle">
            Bagalkot&apos;s home for authentic South Indian breakfast — hot off
            the tawa, served the way it&apos;s always been made.
          </p>
          <p className="camp-hero__address">
            <GeoAlt size={16} className="me-2" />
            Shop No. 2, Jain Mandir Complex, Vidyagiri, Bagalkot
          </p>
          <div className="camp-hero__actions">
            <a href="tel:+916363018056" className="btn-turmeric">
              <TelephoneFill size={16} /> Call Us
            </a>
            <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="btn-leaf-outline">
              WhatsApp Us
            </a>
          </div>
        </div>
        <div className="camp-hero__art">
          <img
            src="/images/dishes/masaladosa.jpg"
            alt="Crisp masala dosa served with chutney and sambar"
            className="camp-hero__photo"
            fetchpriority="high"
          />
        </div>
      </Container>
      <LeafDivider tone="var(--baale-white)" />
    </section>
  );
};

export default Herocamp;
